@if (items.length > 0) {
  <div class="flex w-full flex-wrap gap-2">
    @for (item of visibleItems; track trackByValue($index, item)) {
      <span class="inline-flex items-center rounded-3xl bg-lGray700 px-3 py-1 text-sm text-lWhite">
        <span>{{ item.label }}</span>
        @if (removable) {
          <button
            type="button"
            class="ml-2 cursor-pointer border-none bg-transparent text-lg leading-none text-lWhite transition-colors hover:text-lGray200"
            aria-label="Remover"
            (click)="onRemove($event, item.value)"
          >
            &times;
          </button>
        }
      </span>
    }

    @if (hiddenItemsCount > 0) {
      <span
        class="inline-flex cursor-pointer items-center rounded-3xl bg-lGray700 px-3 py-1 text-sm text-lWhite"
        [pTooltip]="hiddenItemsTooltip"
        tooltipPosition="top"
      >
        {{ overflowPrefix }} {{ hiddenItemsCount }}
      </span>
    }
  </div>
} @else if (label) {
  <span class="inline-flex items-center rounded-3xl bg-lGray700 px-3 py-1 text-sm text-lWhite">
    <span>{{ label }}</span>

    @if (removable) {
      <button
        type="button"
        class="ml-2 cursor-pointer border-none bg-transparent text-lg leading-none text-lWhite transition-colors hover:text-lGray200"
        aria-label="Remover"
        (click)="onRemove($event, label)"
      >
        &times;
      </button>
    }
  </span>
}
